// Mirror sincronizado con backend/internal/models/admin.go.
// Si cambia uno, debe cambiar el otro.
//
// Este allowlist es solución tactical hasta Sprint W12+ multi-clinic switcher
// (ver decisions.md D38). Mientras tanto, frontend lee primero
// `auth.user.is_platform_admin` (computed server-side, anti-tamper) y solo
// cae a este mirror local si el flag falta.
export const WISERVET_ADMIN_EMAILS = [
  'martin@wiservet.com',
  'comercial@wiservet.com', // Sofía con su correo de trabajo (CEO 27-oct-2026)
];

export function isWiservetAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const normalized = email.toLowerCase().trim();
  return WISERVET_ADMIN_EMAILS.includes(normalized);
}

// Acceso ACOTADO a la Academia interna (curso de ventas) SIN ser superadmin.
// Mirror sincronizado con backend/internal/models/admin.go (academyAllowlist).
export const WISERVET_ACADEMY_EMAILS = ['sbertoni33@gmail.com'];

// canAccessAcademyEmail: superadmins Wiservet o emails del allowlist de academia.
export function canAccessAcademyEmail(email: string | null | undefined): boolean {
  if (isWiservetAdminEmail(email)) return true;
  if (!email) return false;
  const normalized = email.toLowerCase().trim();
  return WISERVET_ACADEMY_EMAILS.includes(normalized);
}

// Acceso ACOTADO de alta de clínicas (onboarding) SIN ser superadmin completo.
// Mirror sincronizado con backend/internal/models/admin.go (onboarderAllowlist).
// Vacío hoy: Sofía es superadmin pleno (WISERVET_ADMIN_EMAILS). Mecanismo para
// futuros partners de onboarding acotados.
export const WISERVET_ONBOARDER_EMAILS: string[] = [];

// canOnboardClinicsEmail: superadmins Wiservet o emails del allowlist de onboarding.
// Sólo habilita la vista "Nueva clínica" — NO el resto del panel admin.
export function canOnboardClinicsEmail(email: string | null | undefined): boolean {
  if (isWiservetAdminEmail(email)) return true;
  if (!email) return false;
  const normalized = email.toLowerCase().trim();
  return WISERVET_ONBOARDER_EMAILS.includes(normalized);
}

// SuperAdmin CON ALCANCE (CEO 27-oct-2026): ve todas las secciones como un SuperAdmin,
// pero SOLO en las clínicas que tiene asignadas (clinic_users). NO suplanta ni ve el
// panel global: esos permisos siguen siendo exclusivos de WISERVET_ADMIN_EMAILS.
export const WISERVET_SCOPED_SUPERADMIN_EMAILS = ['mario@wiservet.com'];

export function isScopedSuperadminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return WISERVET_SCOPED_SUPERADMIN_EMAILS.includes(email.toLowerCase().trim());
}
